import type {
  EntityOperationConfig,
  OperationType,
} from '../../types/configuration';

/**
 * Normalizes an `operations[]` entry to its `OperationType` id, regardless of whether
 * the entry was declared as a plain string (`'create'`) or in object form
 * (`{ id: 'create', actionLabel, ... }`).
 */
export const operationId = (
  entry: OperationType | EntityOperationConfig,
): OperationType => (typeof entry === 'string' ? entry : entry.id);
